module.exports = __webpack_public_path__ + "media/images/Movil-resized-b752d3eff8f0a5d4a1943a48371c4c30.svg";